import React from 'react';

const NoMatchPage: React.FC = () => {
    return (
        <div>
            404 - Page not found
        </div>
    );
}

export default NoMatchPage;